@if (showSearchInput && !showSearchInputInside) {
	<div
		(click)="showDropdown.set(enabled())"
		class="search-box search-box-outside"
		[class.disabled]="!enabled()"
		[class.selection-open]="showDropdown()"
		[class.has-selection]="!isEmpty()"
		[attr.aria-label]="label()"
	>
		<input #inp type="text" (input)="searchInput = inp.value" [value]="searchInput" [placeholder]="placeholder" />
		<app-icon class="search-icon" name="search" color="primary-2"></app-icon>
	</div>
}
@if (!showSearchInput || showSearchInputInside) {
	<div
		(click)="showDropdown.set(!showDropdown() && enabled())"
		(mouseenter)="isValueBoxHovered.set(true)"
		(mouseleave)="isValueBoxHovered.set(false)"
		class="value-box text-content"
		[class.disabled]="!enabled()"
		[class.selection-open]="showDropdown()"
		[class.has-selection]="!isEmpty()"
		[attr.aria-label]="label()"
	>
		@if (isEmpty()) {
			<div class="placeholder">{{ placeholder }}</div>
		} @else {
			<div class="selected-value" [title]="getSummary()">{{ getSummary() }}</div>
		}
		<app-icon [name]="chevronIconName()" size="small" class="chevron-icon" [color]="chevronIconColor()"></app-icon>
	</div>
}
@if (showDropdown()) {
	<div
		(clickOutside)="closeDropDown($event)"
		[clickOutsideEvents]="'click,touchend'"
		[delayClickOutsideInit]="true"
		[clickOutsideExclude]="'.search-box'"
		class="selection-box"
		[class.contains-search]="showSearchInput && showSearchInputInside"
		#dropdown
	>
		@if (label()) {
			<div class="heading">{{ label() }}</div>
		}
		@if (showSearchInput && showSearchInputInside) {
			<div class="search-box">
				<input #inp type="text" (input)="searchInput = inp.value" [value]="searchInput" placeholder="Zoeken..." />
				<app-icon class="search-icon" name="search" color="primary-2"></app-icon>
			</div>
		}
		<app-multi-select-checkbox
			[class.no-overflow]="getAllOptions(false).length > 30"
			[options]="getAllOptions()"
			[value]="getSelectedOptions()"
			(valueChange)="setSelectedOptions($event)"
			[inDropdown]="true"
		></app-multi-select-checkbox>
	</div>
}
